import TPL_list_box_item from '../list_box_item.tpl';


export var ListBoxItemView = Backbone.View.extend({

  initialize: function(options) {
    this.template = TPL_list_box_item;

    if (options) {
      if (options.value) {
        this.value = options.value;
        this.value.codeFormat = this.value.code.replace(/[:\/#.@!$*%\\?|]/gi,  Math.floor((Math.random() *1000 )+(Math.random() *100 )+(Math.random() *10 )) );
      }
      if(options.name){
          this.name = options.name;
      }
      if(options.checked){
          this.isChecked = options.checked;
      }
    }
  },


  render: function(){
    var json = {
        val : this.value,
        name: this.name,
    };

    this.$el.html(this.template(json));

    if(this.isChecked){
      this.$el.find('li').addClass('select');
      this.$el.find('input').attr('checked','checked');
    }

    return this;
  },

});
